import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  selectedItem: {
    itemid: '',
    itemname: '',
    itemcode: '',
    unit: '',
  },
  lastSelectedItem: {
    itemid: '',
    itemname: '',
    itemcode: '',
    unit: '',
  }
};

export const inventoryItemSelectionSlice = createSlice({
  name: "inventoryItemSelection",
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedItem: (state, action) => {
      const { itemid, itemname, itemcode, unit } = action.payload;
      
      // Update current selection
      state.selectedItem = { itemid, itemname, itemcode, unit };
      
      // If there's a valid itemid, also update lastSelectedItem for persistence
      if (itemid) {
        state.lastSelectedItem = { itemid, itemname, itemcode, unit };
      }
    },
    clearSelectedItem: (state) => {
      state.selectedItem = INITIAL_STATE.selectedItem;
    },
    restoreLastSelectedItem: (state) => {
      // Restore the last selected item when navigating back
      if (state.lastSelectedItem.itemid) {
        state.selectedItem = { ...state.lastSelectedItem };
      }
    },
    clearAll: (state) => {
      state.selectedItem = INITIAL_STATE.selectedItem;
      state.lastSelectedItem = INITIAL_STATE.lastSelectedItem;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { 
  setSelectedItem, 
  clearSelectedItem, 
  restoreLastSelectedItem, 
  clearAll 
} = inventoryItemSelectionSlice.actions;

export default inventoryItemSelectionSlice.reducer;
